import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class ScenarioScenario extends BasicScenario {
deleteLines: boolean | null;
}

